module.exports = __webpack_public_path__ + "static/img/game-level1.e943357.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-level1.png
// module id = nT0v
// module chunks = 1